import React from 'react';
import styled, { css } from 'styled-components';
import { blockPadV, blockPadH, blockW } from 'theme/mixins/padding';
import type { ResultsBlock as T } from './types';

interface IResultsBlockWrapper {
  borderTop: boolean;
  borderTopColor: string;
  borderBottom: boolean;
  borderBottomColor: string;
}

const Wrapper = styled.div<IResultsBlockWrapper>`
  ${blockPadV({ pt: 'sm', pb: 'sm' })};
  ${blockPadH()};
  background: ${({ theme }) => theme.themeColors.bg};

  ${({ borderTop, borderTopColor, theme }) =>
    borderTop &&
    (borderTopColor
      ? css`
          border-top: 1px solid ${borderTopColor};
        `
      : css`
          border-top: 1px solid ${theme.themeColors.fg}; ;
        `)};

  ${({ borderBottom, borderBottomColor, theme }) =>
    borderBottom &&
    (borderBottomColor
      ? css`
          border-bottom: 1px solid ${borderBottomColor};
        `
      : css`
          border-bottom: 1px solid ${theme.themeColors.fg}; ;
        `)};

  ${({ borderTop, borderTopColor, borderBottom, borderBottomColor, theme }) => theme.mq.md`
${
  borderTop &&
  (borderTopColor
    ? css`
        border-top: 1px solid ${borderTopColor};
      `
    : css`
        border-top: 1px solid rgba(0, 0, 0, 0.2); ;
      `)
};
  ${
    borderBottom &&
    (borderBottomColor
      ? css`
          border-bottom: 1px solid ${borderBottomColor};
        `
      : css`
          border-bottom: 1px solid rgba(0, 0, 0, 0.2); ;
        `)
  };

`}
`;

const Container = styled.div`
  ${blockW('lg')};

  p {
    color: ${({ theme }) => theme.themeColorOpacities.fg50};
    font-size: 1.5rem;
    font-family: ${({ theme }) => theme.fontStacks.sans[0]};
  }
`;

const ResultsBlock: React.FC<T> = ({
  title,
  text,
  borderTop,
  borderTopColor,
  borderBottom,
  borderBottomColor
}) => {
  const boolBorderTop: boolean = borderTop!;
  const boolBorderBottom: boolean = borderBottom!;

  return (
    <Wrapper
      borderTop={boolBorderTop}
      borderTopColor={`${borderTopColor}`}
      borderBottom={boolBorderBottom}
      borderBottomColor={`${borderBottomColor}`}
    >
      <Container>
        <h1>{title}</h1>
        <p>{text}</p>
      </Container>
    </Wrapper>
  );
};

export default ResultsBlock;
